var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.79199 21.875C7.21908 21.875 6.72845 21.6708 6.32012 21.2625C5.91178 20.8542 5.70796 20.3639 5.70866 19.7917V6.25H4.66699V4.16667H9.87533V3.125H16.1253V4.16667H21.3337V6.25H20.292V19.7917C20.292 20.3646 20.0878 20.8552 19.6795 21.2635C19.2712 21.6719 18.7809 21.8757 18.2087 21.875H7.79199ZM9.87533 17.7083H11.9587V8.33333H9.87533V17.7083ZM14.042 17.7083H16.1253V8.33333H14.042V17.7083Z",
    fill: "#7C7C7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.bf3710cf71695302b9c77996f7e96225.svg";
export { ForwardRef as ReactComponent };